/* eslint-disable-next-line */
export interface UploadBlockProps {}

export function UploadBlock(props: UploadBlockProps) {
  return (
    <div>
      <h1>Welcome to UploadBlock!</h1>
    </div>
  );
}

export default UploadBlock;
